import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NoDecimalPipe } from './pipe/no-decimal.pipe';
import { SafePipe } from './pipe/safe.pipe';
import { FilterPipe } from './pipe/filter.pipe';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogService, ConfirmationService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { ContactsComponent } from './components/contacts/contacts.component';
import { SalesOrderComponent } from './components/sales-order/sales-order.component';
import { BootstrapModalModule } from './components/dialog/bootstrap-modal.module';
import { OrderViewComponent } from './components/sales-order/order-view/order-view.component';
import { PendingSalesComponent } from './components/pending-sales/pending-sales.component';
import { RiderAssignComponent } from './components/rider-assign/rider-assign.component';
import { SortByPipe } from './pipe/sortBy.pipe';
import {SerialNumberListComponent} from './components/serialnumberlist/serialnumberlist.component';
import {SerialItemSearchComponent} from './components/serialitem-search/serialitem-search.component';
import {SalesmanComponent} from './components/salesman/salesman.component';
import {BillreportComponent} from './components/billreport/billreport.component';
import { CustomerListComponent } from './components/customer-list/customer-list.component';
import { ItemSearchComponent } from './components/item-search/item-search.component';
import { ListComponent } from './components/list/list.component';
import { DiscountComponent } from './components/discount/discount.component';
import { RemarkComponent } from './components/remark/remark.component';
import { NumpadComponent } from './components/numpad/numpad.component';
import { NumpadPriceComponent } from './components/numpadprice/numpadprice.component';
import { ReportComponent } from './components/report/report.component';
import { AuthComponent } from './components/auth/auth.component';
import { ContactslistComponent } from './components/contactslist/contactslist.component';
import { ListReportComponent } from './components/list-report/list-report.component';
import { LoyaltyComponent } from './components/loyalty/loyalty.component';

@NgModule({
  declarations: [NoDecimalPipe, SafePipe, NumpadComponent, ItemSearchComponent, ContactsComponent, ReportComponent, SalesmanComponent,
    FilterPipe,ListComponent,ContactslistComponent, NumpadPriceComponent, AuthComponent, BillreportComponent, DiscountComponent, RemarkComponent, LoyaltyComponent,
    ListReportComponent, SalesOrderComponent, OrderViewComponent, PendingSalesComponent, RiderAssignComponent, SortByPipe, CustomerListComponent,
    SerialNumberListComponent,SerialItemSearchComponent],

  imports: [
    CommonModule,DynamicDialogModule,TableModule, FormsModule, InputTextModule, TabViewModule,
    BootstrapModalModule.forRoot({ container: document.body })
  ],
  exports: [
    NoDecimalPipe, FormsModule, SafePipe, ContactsComponent, SortByPipe,FilterPipe
  ],
  entryComponents: [
    NumpadComponent, ItemSearchComponent, ReportComponent, SalesmanComponent, ListComponent,
    ContactslistComponent, NumpadPriceComponent, AuthComponent, BillreportComponent, DiscountComponent, RemarkComponent, LoyaltyComponent,
    ListReportComponent, SalesOrderComponent, OrderViewComponent, PendingSalesComponent, RiderAssignComponent,CustomerListComponent,
    SerialNumberListComponent,SerialItemSearchComponent
  ],
  providers: [
    DialogService, ConfirmationService, DatePipe
  ]
})

export class SharedModule { }
